import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  constructor(private commonService: CommonService,  private router: Router) { }

  ngOnInit() {
    this.commonService.fetchConfig().subscribe((response) => {
      const sideBarConfig = this.commonService.getConfigForElementKey(response, 'Side Bar');
      const defaultPage = sideBarConfig.config.defaultValue;
      switch (defaultPage) {
        case 'My Bookings': this.router.navigate(['bookings']); break;
        case 'Request View': this.router.navigate(['requests-view']); break;
        case 'Booking View': this.router.navigate(['bookings-view']); break;
        case 'Billing Reports': this.router.navigate(['billing-report']); break;
        case 'My Profile': this.router.navigate(['profile]']); break;
        case 'Invoicing': this.router.navigate(['invoicing']); break;
        default: this.router.navigate(['bookings']);
      }
    });
  }

}
